import * as React from "react";
import { observer } from "mobx-react";
import { Tabs, Tab, Alert, Button, Alignment, FormGroup, Intent, NonIdealState, Tag, Collapse, Dialog, Classes, HTMLSelect, } from "@blueprintjs/core";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { IEmpresa } from "../../model";
import { formatCnpj } from "../../utils";
import { toast } from "react-toastify";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { AppStore } from "../../stores/AppStore";
import { IntegrationStore } from "../../stores/xml-integracao/IntegrationStore";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import moment from "moment";
import Dominio from "./dominio";
import Questor from "./questor";
import SCI from "./sci";
import { getTag } from "../utils/getStatus";
import { AppIcon } from "../utils/AppIcon";

@observer
export default class IntegrationPage extends React.Component<{}, {}> {

  obs = observable({
    erros: [],
    detalhes_integration: false,
    tipo_api: ""
  })

  constructor(props: {}) {
    super(props);

    AppStore.setTitle("XML Integração")

  }

  async loadConfiguracoes() {

    if (IntegrationStore.obs.selectedEmpresa.cnpj == "") {
      toast.warning('Você precisa selecionar uma empresa para filtrar.', {});
      return
    }

    IntegrationStore.obs.tarefas_page = 1

    IntegrationStore.obs.select_tab_geral = "tarefas"

    this.obs.tipo_api = ""

    await IntegrationStore.handleConsultaTarefa(1, IntegrationStore.obs.selectedEmpresa.cnpj, "");

    await IntegrationStore.handleLoadIntegration(IntegrationStore.obs.selectedEmpresa.cnpj)

    IntegrationStore.obs.isEmpresa = true

  }

  async hanldeChangeTabGeral(tab: string) {

    IntegrationStore.obs.select_tab_geral = tab;

  }

  handleBuscaTarefasPaged = async (page: number) => {

    IntegrationStore.obs.tarefas_page = page

    await IntegrationStore.handleConsultaTarefa(page, IntegrationStore.obs.selectedEmpresa.cnpj, this.obs.tipo_api);

  };

  render() {

    if (!IntegrationStore.obs.isEmpresa) {
      return this.renderBlock();

    } else {
      return this.renderSped();

    }
  }

  renderBlock() {

    let empresaTextProg = IntegrationStore.obs.selectedEmpresa.cnpj != ""
      ? `${IntegrationStore.obs.selectedEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(IntegrationStore.obs.selectedEmpresa.cnpj)})`
      : "Selecione uma empresa";

    let titleEmpresaText = IntegrationStore.obs.selectedEmpresa.cnpj != ""
      ? IntegrationStore.obs.selectedEmpresa.razao_social + " - (" + formatCnpj(IntegrationStore.obs.selectedEmpresa.cnpj) + ")"
      : "";

    return (
      <>
        <MDBCol>
          <MDBRow>
            <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => IntegrationStore.obs.open_select_empresa = true}>Selecionar Empresa</MDBBtn>
            <h2 className="titleSEFAZ titleEmpresaSped">{titleEmpresaText}</h2>
          </MDBRow>
        </MDBCol>

        <div className="nz-non-ideal">
          <NonIdealState
            icon="box"
            description={"Selecione uma Empresa para realizar as Configurações"} />
        </div>

        <Alert
          cancelButtonText="Fechar"
          confirmButtonText="Carregar"
          isOpen={IntegrationStore.obs.open_select_empresa}
          onClose={() => IntegrationStore.obs.open_select_empresa = false}
          onConfirm={() => this.loadConfiguracoes()}
          className="AlertUser"
          canOutsideClickCancel={true}
          intent={Intent.PRIMARY}
        >
          <h2 className="titleSEFAZ">Selecione uma Empresa</h2>
          <FormGroup
            className="empresaSelect"
          >
            <EmpresaSelect
              items={EmpresaStore.sortedEmpresas}
              itemRenderer={renderEmpresa}
              itemPredicate={filterEmpresa}
              onItemSelect={(e: IEmpresa) => IntegrationStore.obs.selectedEmpresa = e}
              inputProps={{ placeholder: "Filtrar uma empresa" }}
            >
              <Button
                text={empresaTextProg}
                rightIcon="double-caret-vertical"
                alignText={Alignment.LEFT}
              />
            </EmpresaSelect>
          </FormGroup>
        </Alert>
      </>
    );
  }

  handleCloseDetalhes() {
    this.obs.detalhes_integration = false
    this.obs.erros = []
  }

  async handleCheckTipo(modelo: string) {

    this.obs.tipo_api = modelo

    await IntegrationStore.handleConsultaTarefa(1, IntegrationStore.obs.selectedEmpresa.cnpj, modelo);

  }

  renderSped() {

    let empresaTextProg = IntegrationStore.obs.selectedEmpresa.cnpj != ""
      ? `${IntegrationStore.obs.selectedEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(IntegrationStore.obs.selectedEmpresa.cnpj)})`
      : "Selecione uma empresa";

    let titleEmpresaText = IntegrationStore.obs.selectedEmpresa.cnpj != ""
      ? IntegrationStore.obs.selectedEmpresa.razao_social + " - (" + formatCnpj(IntegrationStore.obs.selectedEmpresa.cnpj) + ")"
      : "";

    function statusFormatter(cell, row) {

      return getTag(row.status, "xml_integration");

    }

    function dateFormatter(cell, row) {

      return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " ás " + moment(cell).add(3, "hour").format("HH:mm");

    };

    function stringFormatter(cell, row) {

      return (cell)?.toUpperCase();

    };

    function cnpjFormatter(cell, row) {
      if (row.cnpj) {

        let emp = EmpresaStore.getByCnpj(row.cnpj);

        if (emp) {
          return `${emp.razao_social.substring(0, 30)} - ${formatCnpj(row.cnpj)}`
        }

      }

      return ""

    };

    function buttonFormatterDetalhes(cell, row) {
      return (
        <>
          <MDBBtn disabled={!row._id} color="default" rounded size="sm" onClick={(e) => handleViewDetalhes(row)} >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>
        </>
      );
    }

    function fileFormatter(cell, row) {

      const _inserted_at = new Date(row.inserted_at)

      const limiteDownload = new Date(_inserted_at)

      limiteDownload.setDate(limiteDownload.getDate() + 30)

      const downloadExpirado = new Date() > limiteDownload

      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            disabled={downloadExpirado}
            onClick={() => {
              if (!downloadExpirado) {
                IntegrationStore.handleDownloadArquivoIntegration(row.integration_id)
              }
            }}
          >
            <img src="/images/download.svg" />
          </MDBBtn>
        </>
      )
    }

    const handleViewDetalhes = async (row) => {

      if (row.error && row.status != 2 && row.error.length) {

        this.obs.erros = row.error

      } else {

        this.obs.erros = []

      }

      this.obs.detalhes_integration = true

    };

    return (
      <>
        <MDBCol>
          <MDBRow>
            <MDBBtn className="btnDefault btnBuscarNfe" onClick={() => IntegrationStore.obs.open_select_empresa = true}>Selecionar Empresa</MDBBtn>
            <h2 className="titleSEFAZ titleEmpresaSped">{titleEmpresaText}</h2>
          </MDBRow>
        </MDBCol>

        <Tabs
          id="tabs"
          className={"tabsCalculos"}
          data-tut="resumo"
          selectedTabId={IntegrationStore.obs.select_tab_geral}
          onChange={(tabId) => this.hanldeChangeTabGeral(String(tabId))}
        >

          <Tab
            id="tarefas"
            title="Tarefas"
            panel={
              <>

                <div className="alert alert-warning" style={{ display: "inherit" }}>
                  <AppIcon size={20} name="warning" style={{ marginRight: 10 }} />
                  Os arquivos ficam disponíveis para download por 30 dias após a criação, após este período eles devem ser baixados através do menu de NF-e, NFC-e, CT-e e NFS-e. <br />
                </div>

                <FormGroup label="Tipo de Integração" style={{ width: "20%" }}>
                  <HTMLSelect
                    onChange={(e) => this.handleCheckTipo(e.target.value)}
                    value={this.obs.tipo_api}
                  >
                    <option value="">Todas</option>
                    <option value="dominio">Domínio</option>
                    <option value="questor">Questor</option>
                    <option value="sci">SCI</option>
                  </HTMLSelect>
                </FormGroup>

                <BootstrapTable className="TableDefaultImport" data={IntegrationStore.obs.tarefas} style={{ marginTop: 10 }}>
                  <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%"> # </TableHeaderColumn>
                  <TableHeaderColumn dataFormat={cnpjFormatter} width="30%">Empresa</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="15%">Data</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={stringFormatter} dataField="tipo" width="10%">Tipo</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={stringFormatter} dataField="modelo" width="10%">Modelo</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={stringFormatter} dataField="estado" width="10%">Estado</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={stringFormatter} dataField="type_api" width="10%">Integração</TableHeaderColumn>
                  <TableHeaderColumn dataField="total_notas" width="15%">Total Notas</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={statusFormatter} width="20%">Status</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="10%">Detalhes</TableHeaderColumn>
                  <TableHeaderColumn dataFormat={fileFormatter} width="10%">Arquivos</TableHeaderColumn>
                </BootstrapTable>

                <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
                  <Pager
                    currentPage={IntegrationStore.obs.tarefas_page}
                    totalCount={IntegrationStore.obs.tarefas_length}
                    pageSize={15}
                    onPageChange={page => this.handleBuscaTarefasPaged(page)}
                  />
                </div>

              </>
            }
          />

          <Tab
            id="dominio"
            title="Domínio"
            panel={<Dominio />}
          />

          <Tab
            id="questor"
            title="Questor"
            panel={<Questor />}
          />

          <Tab
            id="sci"
            title="SCI"
            panel={<SCI />}
          />

        </Tabs>

        <Alert
          cancelButtonText="Fechar"
          confirmButtonText="Carregar"
          isOpen={IntegrationStore.obs.open_select_empresa}
          onClose={() => IntegrationStore.obs.open_select_empresa = false}
          onConfirm={() => this.loadConfiguracoes()}
          className="AlertUser"
          canOutsideClickCancel={true}
          intent={Intent.PRIMARY}
        >
          <h2 className="titleSEFAZ">Selecione uma Empresa</h2>
          <FormGroup
            className="empresaSelect"
          >
            <EmpresaSelect
              items={EmpresaStore.sortedEmpresas}
              itemRenderer={renderEmpresa}
              itemPredicate={filterEmpresa}
              onItemSelect={(e: IEmpresa) => IntegrationStore.obs.selectedEmpresa = e}
              inputProps={{ placeholder: "Filtrar uma empresa" }}
            >
              <Button
                text={empresaTextProg}
                rightIcon="double-caret-vertical"
                alignText={Alignment.LEFT}
              />
            </EmpresaSelect>
          </FormGroup>
        </Alert>

        <Dialog isOpen={this.obs.detalhes_integration} onClose={() => this.handleCloseDetalhes()}>
          <div className={Classes.DIALOG_BODY}>
            <MDBCol md="12">
              {this.obs.erros.length ?
                <div className="flash-error">
                  <div style={{ textAlign: "center", marginTop: 0 }}>
                    <img
                      src="/images/erro_calculo.svg"
                      width={50}
                      style={{ display: "inline-block" }}
                    />
                    <h3>Erros foram encontrados</h3>

                    <br />

                    <div style={{ maxHeight: 350, overflow: "auto" }}>
                      {this.obs.erros.map(values => {
                        return <p>{values}</p>
                      })}
                    </div>

                  </div>
                </div>
                :
                <div className="flash-error">
                  <div style={{ textAlign: "center", marginTop: 50 }}>
                    <img
                      src="/images/pass_calculo.png"
                      width={50}
                      style={{ display: "inline-block" }}
                    />
                    <h3 style={{ color: "#46eb7d" }}>Nenhum erro encontrado</h3>
                  </div>
                </div>
              }
            </MDBCol>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent='primary' onClick={() => this.handleCloseDetalhes()} />
            </div>
          </div>
        </Dialog>

      </>
    );
  }
}